import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getTokenFromCookie } from '../../utils/constants';

/**
 * AuthProtectedRoute Component
 * Restricts access to routes that require authentication
 * Redirects unauthenticated users to login page
 */
const AuthProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state.user);
  const token = getTokenFromCookie();

  // If user is not logged in (no user in Redux or no token), redirect to login
  if (!user || !token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default AuthProtectedRoute;
